import Tippy from "@tippyjs/react";
import React, { forwardRef } from "react";
import { animateFill } from "tippy.js";
import { hideAllPoppersInstantly } from "helpers/randomHelpers";
import "tippy.js/dist/tippy.css";

const EfsTippy = forwardRef(
  ({ className = "normal-Tippy", content, children, ...rest }, ref) => {
    return (
      <Tippy
        onShow={hideAllPoppersInstantly}
        delay={[0, 0]}
        animateFill={true}
        plugins={[animateFill]}
        animation="shift-away"
        popperOptions={{
          modifiers: [
            {
              name: "preventOverflow",
              options: {
                altAxis: true,
                tether: false,
              },
            },
          ],
        }}
        appendTo={document.getElementById("space-and-video")}
        content={<div className={`dotdotdot ${className}`}>{content}</div>}
        {...rest}
      >
        {React.cloneElement(children, { ref: ref })}
      </Tippy>
    );
  }
);

export default EfsTippy;
